import { render, staticRenderFns } from "./kpiConfiguration.vue?vue&type=template&id=24b4b05c&scoped=true&"
import script from "./kpiConfiguration.vue?vue&type=script&lang=js&"
export * from "./kpiConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./kpiConfiguration.vue?vue&type=style&index=0&id=24b4b05c&prod&lang=css&"
import style1 from "./kpiConfiguration.vue?vue&type=style&index=1&id=24b4b05c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b4b05c",
  null
  
)

export default component.exports